import { useEffect } from 'react';
import { create } from 'zustand';

interface PageTitleState {
  title: string;
  set: (title: string) => void;
}

export const usePageTitleStore = create<PageTitleState>((set) => ({
  title: '',
  set: (title) => set({ title })
}));

/// <summary>
/// Page-level hook: declare the current page's title on mount, clear on
/// unmount. The Header reads the store to render the title in its center
/// column on mobile. Also keeps the browser tab title in sync.
/// </summary>
export function usePageTitle(title: string) {
  const set = usePageTitleStore((s) => s.set);
  useEffect(() => {
    set(title);
    document.title = `${title} — ReceiptRaptor`;
    return () => set('');
  }, [title, set]);
}
